import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { FilterHintEvents } from '@/enums/events';
import { isAnyFilterActive } from '@/helpers/filter-helper';
import { FilterName, getDefaultFilterCollection } from '@/stores/filter.store';
import BasicButton from '@/ui-components/BasicButton.vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { TrackingProviderPropertiesInterface } from '@/helpers/tracking/providers';
import { useFilterStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineEmptyState',
  props: {
    hasNoTitles: { type: Boolean, default: false },
    isAtEndOfList: { type: Boolean, default: false }
  },
  emits: ['onScrollToTop'],
  setup(__props: any, { emit: emits }) {

const props = __props as { hasNoTitles: boolean, isAtEndOfList: boolean };



const { t } = useI18n();

const { reset, resetFilters, currentFilters } = useFilterStore();


const filterNames = Object.keys(getDefaultFilterCollection()).filter(
	filterName => !['content_types', 'inner_tab'].includes(filterName)
) as FilterName[];

const hasFiltersActive = computed(() => {
	const filters: FilterName[] = [...Object.keys(currentFilters.value)] as FilterName[];
	return isAnyFilterActive(filters, currentFilters.value);
});

const btnText = computed(() => {
	return hasFiltersActive.value ? t('WEBAPP_CLEAR_FILTERS') : t('WEBAPP_GO_TO_TOP');
});

const reelBackground = computed(() => {
	return {
		'background-image': `url('/${ASSETS_DIR}/img/film-reel.png')`,
		'background-repeat': 'no-repeat',
		'background-position-x': 'center',
	};
});

function visibilityChanged(isVisible: boolean) {
	if (isVisible) {
		trackEvent(FilterHintEvents.SHOWN);
	}
}

const emptyStateContent = computed(() => {
	if (props.hasNoTitles) {
		return {
			headline: t('WEBAPP_TIMELINE_NO_RESULTS_HEADLINE'),
			text: t('WEBAPP_TIMELINE_NO_RESULTS_TEXT'),
		};
	} else if (props.isAtEndOfList) {
		return {
			headline: t('WEBAPP_TIMELINE_END_OF_TIMELINE_HEADLINE'),
			text: t('WEBAPP_TIMELINE_END_OF_TIMELINE_TEXT'),
		};
	} else {
		return { headline: '', text: '' };
	}
});

onMounted(() => {
	trackEvent(FilterHintEvents.LOADED);
});

function clicked() {
	if (hasFiltersActive.value) {
		if (filterNames.length) {
			resetFilters({ filterNames });
		} else {
			reset();
		}
	} else {
		emits('onScrollToTop');
	}
}

function trackEvent(action: FilterHintEvents): void {
	const label =
		(props.isAtEndOfList && FilterHintEvents.NO_MORE_TITLES) ||
		(props.hasNoTitles && FilterHintEvents.NO_TITLES) ||
		'';

	const properties: TrackingProviderPropertiesInterface = { action, label };
	if ([FilterHintEvents.SHOWN, FilterHintEvents.LOADED].includes(action)) properties.nonInteraction = true;

	TrackingHelper.trackEvent('filter_hint', properties);
}

return { __sfc: true,props, t, reset, resetFilters, currentFilters, emits, filterNames, hasFiltersActive, btnText, reelBackground, visibilityChanged, emptyStateContent, clicked, trackEvent, BasicButton }
}

})